"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReadOnlyPrettyText_1 = require("./ReadOnlyPrettyText");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return ReadOnlyPrettyText_1.default; } });
